import { normalize } from 'normalizr';
import * as schema from '../schema';

import * as actionTypes from './actionTypes';
import { axiosProtected, axiosDownload } from '../../axios-wizard';
import FileDownload from 'js-file-download'


export const getDocumentationFiles = (state, productSystemId) => {
  if (state.inventory !== undefined && state.inventory.documentationFiles !== undefined) {
    const x = Object.values(state.inventory.documentationFiles).filter(x => x.product_system_id === productSystemId);
    return (Array.isArray(x))? x : undefined;
  } else {
    return [];
  }
}


export const fetchDocumentationFilesStart = (  ) => {
    return {
        type: actionTypes.FETCH_DOCUMENTATIONFILES_START
    };
};

export const fetchDocumentationFilesSuccess = ( files ) => {
    return {
        type: actionTypes.FETCH_DOCUMENTATIONFILES_SUCCESS,
        values: files
    };
};

export const fetchDocumentationFilesFailed = () => {
    return {
        type: actionTypes.FETCH_DOCUMENTATIONFILES_FAILED
    };
};


export const fetchFilteredPenetrationsDocuments = (a) => {
    const url = '/api/penetration_filters_documents'

    return dispatch => {
        //dispatch( fetchProductsystemsStart() );
        return axiosProtected.get( url )
            .then( response => {
               //const normalized = normalize(response.data, { product_systems: schema.arrayOfProductSystems })
               //dispatch(fetchProductsystemsSuccess(normalized));
               return response.data //normalized.result.product_systems
            } )
            .catch( error => {
                //dispatch(fetchProductsystemsFailed());
            } );
    };
};

export const fetchAllDocumentationFiles = () => {
    const url = '/api/documentation_files'


    return dispatch => {
        dispatch( fetchDocumentationFilesStart() );
        return axiosProtected.get( url )
            .then( response => {
               const normalized = normalize(response.data, { documentation_files: schema.arrayOfDocumentationFiles })
               dispatch(fetchDocumentationFilesSuccess(normalized));
               return normalized.result.documentation_files
            } )
            .catch( error => {
                dispatch(fetchDocumentationFilesFailed());
            } );
    };
};


export const downloadDocumentationPdf = (filename, docId) => {

    const url = '/api/documentation_files/' + docId;

    const today = new Date();

    return dispatch => {

        return axiosDownload.get( url )
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/documentation_files.js